import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:이재호
 * 화면기능:택배정산알림 팝업
 * 세부설명:
*/

export class AccountMsgDtl extends Component {
    static displayName = AccountMsgDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            Allim_Mgt: []
        };
        this.ref_AccountMsgDtl = React.createRef();
    }
    //초기화
    componentDidMount() {
    }
    async initData(alim_cd) {
        try {

            let Data = await Big3Common.Post('api/MyPage/Notice/GetAccountAlim', { alim_cd: alim_cd }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const Allim_Mgt = JSON.parse(Data.dataTable);
                this.setState({
                    Allim_Mgt: Allim_Mgt[0]
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("initData", e);
        }
        return false;
    }
    render() {
        const list = this.state.Allim_Mgt
            return (
                <div ref={this.ref_AccountMsgDtl} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered ">
                        <div className="modal-content ordertype_modal">
                            <div className="modal-body text-center ">
                                <div className="desc ordertype_modal_in">
                                    <div className="modal_title">{list.contentfld1}</div>
                                </div>
                                <div className="delivery_text_modal_box">
                                    <p>
                                        {list.contentfld2}
                                    </p>
                                    <div>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: list.contentfld3
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="ok_btn_box">
                                    <button data-bs-dismiss="modal">확인</button>
                                </div>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                        </div>
                    </div>
                </div>
            );
    }
}
